import { CarOutlined } from '@ant-design/icons';
import { Button, Input, message, Popover, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { fetchAPI } from '../../utils/api';
import { OrderOperationStatus } from './utils';

const OrderInputTrackingNumber = (props: {
  record: any;
  onSuccess: () => void;
}) => {
  const [value, setValue] = useState('');
  const [openTooltip, setOpenTooltip] = useState(false);
  const [loading, setLoading] = useState(false);

  const saveTrackingNumber = async () => {
    setLoading(true);
    try {
      await fetchAPI('orders/sync-tracking-number-to-99sme', {
        method: 'POST',
        payload: {
          order_id: props.record?.id,
          tracking_number: value,
        },
      });
      message.success('Tracking Number Updated!');
      setOpenTooltip(false);
      props.onSuccess();
    } catch (error) {
      message.error('Failed set Tracking Number');
    }
    setLoading(false);
  };

  useEffect(() => {
    if (props.record?.id) {
      setValue(props.record?.tracking_number || '');
      setOpenTooltip(false);
      setLoading(false);
    }
  }, [props.record?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (
    !props.record?.po_reference_number ||
    props.record?.operation_status !== OrderOperationStatus.PENDING_DELIVERY
  ) {
    return null;
  }

  return (
    <Popover
      trigger={'click'}
      placement="bottom"
      title="Input Tracking Number"
      visible={openTooltip}
      onVisibleChange={visible => setOpenTooltip(visible)}
      content={
        <Wrapper>
          <Input
            placeholder="Tracking Number"
            value={value}
            onChange={e => {
              e.persist();
              let val = e.target?.value || '';
              if (val.length <= 50) {
                setValue(val);
              }
            }}
            max={50}
          />
          <Button
            type="primary"
            loading={loading}
            onClick={() => saveTrackingNumber()}
            disabled={!value}
          >
            Save
          </Button>
        </Wrapper>
      }
    >
      <Tooltip title="Input Tracking Number">
        <Button icon={<CarOutlined />}>Input Tracking</Button>
      </Tooltip>
    </Popover>
  );
};

const Wrapper = styled.div`
  text-align: right;

  .ant-input {
    margin-bottom: 10px;
  }
`;

export default OrderInputTrackingNumber;
